<template>
  <v-container grid-list-xl>
    <v-form ref="form" lazy-validation>
      <v-alert :value="true" color="error" icon="warning" v-if="showAlert">
        <p v-html="$t('message.cuotas.periodo.alerta85')"></p>
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm6 md2>
          <DatePicker
            id="periodoConsumoPeriodo"
            v-model="form.periodoConsumo"
            placeholder="dd/mm/yyyy"
            :pickerOptions="allowedDays"
            :label="$t('message.cuotas.periodo.periodo')"
            :rules="rules.periodo"
            :error-messages="periodoErrorMessage"
          ></DatePicker>
        </v-flex>
        <v-flex xs12 sm6 md3 v-if="isTarifa">
          <Numeric
            id="preciofacturacionPeriodo"
            v-model="form.facturacion"
            @input.native="changeBaseImponible(form)"
            currency="€"
            :label="$tc('message.cuotas.periodo.facturacion', 1)"
          ></Numeric>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <Numeric
            id="nukwhfacPeriodo"
            v-model="form.nukwhfac"
            currency="kwh"
            :precision="0"
            :label="$t('message.cuotas.periodo.nukwhfac')"
          ></Numeric>
        </v-flex>
        <v-flex xs12 sm6 md3 v-if="isTarifa">
          <Numeric
            id="base"
            :label="$tc('message.cuotas.periodo.base', 1)"
            v-model="form.baseImponible"
            currency="€"
            readonly
          ></Numeric>
        </v-flex>
        <v-flex xs12 sm6 md4 v-if="!isTarifa">
          <Numeric
            id="base"
            :label="$tc('message.cuotas.periodo.base', 1)"
            v-model="form.baseImponible"
            currency="€"
          ></Numeric>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-end row fill-height>
        <Boton id="btnCancelar" tipo="warning" :onclick="onCancel">{{
          $t('message.comun.cancelar')
        }}</Boton>
        <Boton id="btnGuardar" tipo="warning" :onclick="onSubmit">{{
          $t('message.comun.guardar')
        }}</Boton>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { getVigenciaBaseCotizacionEmpresa } from '@/api/empresas';
import { Numeric, DatePicker, Boton } from '@/components';
import { FECHA_INICIO_ELEC } from '../cuotasConst';
import { mapActions } from 'vuex';
import moment from 'moment';
export default {
  name: 'periodoElecCuota',
  props: {
    model: {
      type: Object,
      required: true
    },
    mesFacturacion: {
      type: Date,
      required: true
    },
    isTarifa: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true,
      validator(value) {
        return value === 'new' || value === 'modify';
      }
    }
  },
  components: {
    Numeric,
    DatePicker,
    Boton
  },
  data() {
    return {
      form: {
        id: '',
        cuotas: [],
        idBaseCo: 0,
        periodoConsumo: null,
        facturacion: 0,
        nukwhfac: 0,
        baseImponible: 0
      },
      rules: {
        periodo: [() => this.periodoConsumoChangeHandler()]
      },
      periodoErrorMessage: [],
      precisionTipo: 3,
      showAlert: false
    };
  },
  created() {
    Object.assign(this.form, this.model);
  },
  methods: {
    ...mapActions(['setLoading']),
    allowedDays(val) {
      // Menos que la fecha de facturación y más que 2009
      return (
        moment(val).toDate() >= moment(FECHA_INICIO_ELEC).toDate() &&
        moment(val).toDate() <=
          moment(this.mesFacturacion)
            .endOf('month')
            .toDate()
      );
    },
    onSubmit() {
      if (this.periodoErrorMessage.length === 0) {
        // Calculamos la cuota tributaria de todas las cuotas
        for (let count in this.form.cuotas) {
          if (this.form.cuotas[count].tipo == null) {
            this.form.cuotas[count].cuotaTributaria = null;
          } else {
            this.form.cuotas[count].cuotaTributaria = Math.round10(
              (this.form.baseImponible * this.form.cuotas[count].tipo) / 100,
              -2
            );
          }
          if (!this.isTarifa) {
            this.form.facturacion = this.form.baseImponible;
          }
        }
        this.$emit('modify', this.form);
      }
    },
    onCancel() {
      this.form = {};
      this.$emit('cancel');
    },
    changeBaseImponible(periodo) {
      if (isNaN(periodo.facturacion)) {
        periodo.baseImponible = 0;
      } else {
        periodo.baseImponible = periodo.facturacion;
      }
    },
    periodoConsumoChangeHandler() {
      // Campo obligatorio
      if (this.form.periodoConsumo == null || this.form.periodoConsumo === '') {
        this.periodoErrorMessage = ['campo obligatorio'];
        return true;
      }
      this.setLoading(true);
      // Validamos la vigencia de la fecha
      let payload = {
        id: this.form.id,
        idEmpresa: this.$store.getters.empresaSelected.idempres,
        idCuota: null,
        idBaseCotizacion: this.form.idBaseCo,
        fechaConsumo: moment(this.form.periodoConsumo).valueOf()
      };
      let promesas = [];
      for (let cuota in this.form.cuotas) {
        payload.idCuota = this.form.cuotas[cuota].id;
        let tipo = getVigenciaBaseCotizacionEmpresa(payload);
        promesas.push(tipo);
      }

      let self = this;
      Promise.all(promesas.map(p => p.catch(e => e))).then(results => {
        self.periodoErrorMessage = ['No se aplica cuota para el periodo elegido'];
        for (let count in results) {
          if (!(results[count] instanceof Error)) {
            self.form.cuotas[count].tipo = results[count].data.nuporcen;
            self.periodoErrorMessage = [];
          } else {
            self.form.cuotas[count].tipo = null;
          }
        }
        this.setLoading(false);
        if (
          self.periodoErrorMessage.length > 0 &&
          moment(self.form.periodoConsumo).format('YYYY') >= 2021
        ) {
          self.showAlert = true;
        } else {
          self.showAlert = false;
        }
      });
      return true;
    }
  }
};
</script>
